import React from 'react';
import { withPropsOnChange } from 'recompose';

import { SearchFilterContent } from 'components/search/SearchFilterContent';
import { TruckFilterContent } from 'components/search/TruckFilterContent';
import { VehicleSearchFilters } from 'components/search/VehicleSearchFilters';

export default withPropsOnChange(
	['isTruckSerp', 'isVehicleSerp', 'facetCounts'],
	({
		isTruckSerp, isVehicleSerp, handleShowUnitGuide, priceTransparency, cityUrl, pageType, facetCounts,
		useNewSearch,
	}) => {
		let filterComponent = (
			<SearchFilterContent
				onShowUnitGuide={handleShowUnitGuide}
				priceTransparency={priceTransparency}
				cityUrl={cityUrl}
				pageType={pageType}
				facetCounts={facetCounts}
			/>
		);

		if (isTruckSerp) {
			filterComponent = (
				<TruckFilterContent  />
			);
		} else if (isVehicleSerp) {
			filterComponent = (
				<VehicleSearchFilters useNewSearch={useNewSearch} facetCounts={facetCounts} />
			);
		}

		return {
			filterComponent,
			listType: isTruckSerp ? 'grid' : 'column'
		};
	}
);
